module.exports = __webpack_public_path__ + "img/he7.9aaf10ab.png";